import { cn } from "@repo/utils";

export default function OffreAbonnementEchosPJ() {
  return (
    <div className={cn("flex justify-center")}>
      <img
        src="/images_pj/abonnement_les_echos.png"
        width={1500}
        height={1000}
        alt="offre_les_echos"
      />
    </div>
  );
}

OffreAbonnementEchosPJ.title = "Offre Abonnement les Echos";
